import { API_SEARCH } from 'Constants/client-modules';
import * as ACTION_TYPES from './types';

const clientName = API_SEARCH;
export function searchPatients(doctorId, params, isMore = false) {
  return {
    types: [
      ACTION_TYPES.PATIENT_SEARCH_REQUESTED,
      ACTION_TYPES.PATIENT_SEARCH_SUCCEED,
      ACTION_TYPES.PATIENT_SEARCH_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/search-consult`, { params }),
    options: {
      clientName,
    },
    meta: { isMore },
  };
}

export function loadMorePatients(name, page, offset) {
  return {
    types: [
      ACTION_TYPES.PATIENT_SEARCH_MORE_REQUESTED,
      ACTION_TYPES.PATIENT_SEARCH_MORE_SUCCEED,
      ACTION_TYPES.PATIENT_SEARCH_MORE_FAILED,
    ],
    promise: client => client.get(
      '/teleconsult-search/patients',
      {
        params: {
          name, limit: 10, page, offset,
        },
      },
    ),
    options: {
      clientName,
    },
  };
}

export function clearPatients() {
  return {
    type: ACTION_TYPES.PATIENT_CLEAR_SEARCH,
  };
}

export function gotoPatient(conversation) {
  return {
    type: ACTION_TYPES.PATIENT_GOTO_SEARCH,
    payload: conversation,
  };
}

export function searchMessages(query) {
  return {
    types: [
      ACTION_TYPES.MESSAGES_PATIENT_SEARCH_REQUESTED,
      ACTION_TYPES.MESSAGES_PATIENT_SEARCH_SUCCEED,
      ACTION_TYPES.MESSAGES_PATIENT_SEARCH_FAILED,
    ],
    promise: client => client.get(
      '/teleconsult-search/chat-messages',
      { params: { query, limit: 50, category: 'fee' } },
    ),
    options: {
      clientName,
    },
  };
}

export function searchDoctors(doctorId, params, isLoadMore) {
  return {
    types: [
      ACTION_TYPES.SEARCH_DOCTORS_INVITATION_REQUESTED,
      ACTION_TYPES.SEARCH_DOCTORS_INVITATION_SUCCEED,
      ACTION_TYPES.SEARCH_DOCTORS_INVITATION_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/invite-doctor`, { params }),
    options: {
      clientName,
    },
    meta: {
      isLoadMore,
    },
  };
}
